var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h20v20H0z"
      }
    }), _c('path', {
      attrs: {
        "d": "M18.215 1h-5.429c-.39 0-.754.264-.82.65a.785.785 0 00.772.917h4.304c.216 0 .392.175.392.391v4.257c0 .39.263.755.65.82A.785.785 0 0019 7.263V1.781A.79.79 0 0018.215 1zM7.26 17.433H2.958a.392.392 0 01-.392-.391v-4.255c0-.39-.263-.755-.65-.82a.785.785 0 00-.916.772v5.478c0 .43.351.783.783.783h5.429c.39 0 .755-.264.82-.65a.785.785 0 00-.772-.917h0zm1.068-9.497l-.002-.014V4.025a.786.786 0 00-.783-.784.786.786 0 00-.784.784v2.021L3.12 2.4a.785.785 0 00-1.107 0 .785.785 0 000 1.107l3.643 3.645h-2.02a.786.786 0 00-.784.784c0 .43.351.783.783.783h3.897l.013.002a.762.762 0 00.417-.124c.004-.004.01-.006.015-.008a.853.853 0 00.22-.22c.004-.004.006-.01.007-.013a.785.785 0 00.125-.42h0zm6.015 5.302h2.02c.43 0 .784-.352.784-.784a.786.786 0 00-.783-.783h-3.897l-.013-.002a.768.768 0 00-.419.124c-.003.002-.01.004-.013.008a.853.853 0 00-.22.22l-.007.013a.769.769 0 00-.125.418l.002.014v3.897c0 .43.352.784.784.784.43 0 .783-.352.783-.784v-2.02l3.643 3.644a.785.785 0 001.106 0 .785.785 0 000-1.106l-3.645-3.643z",
        "stroke": "#797979",
        "stroke-width": ".1",
        "fill": "#797979",
        "fill-rule": "nonzero"
      }
    })])]));
  }
};